<template>
    <v-dialog v-if="estimate" max-width="1440px" v-model="show">
        <v-card class="estimate-2">
            <v-card-title>
                상세견적
                <v-spacer />
                <v-btn v-if="editable" color="secondary" text @click="tempLoad()">임시저장 불러오기</v-btn>
                <v-btn v-if="editable" color="primary" text @click="tempSave()">임시저장</v-btn>
            </v-card-title>
            <v-card-text class="px-3">
                <v-divider />
                <v-responsive width="100%">
                    <v-divider class="mx-0" />
                    <v-row align="center" class="red lighten-4 mx-0">
                        <v-col cols="auto" class="py-0 text-center">
                            자재
                        </v-col>
                        <v-divider vertical />
                        <v-col class="py-0">
                            <v-row class="red lighten-4" align="center">
                                <v-col cols="2" class="text-center">
                                    위치
                                </v-col>
                                <v-divider vertical />
                                <v-col class="py-0">
                                    <v-row class="yellow lighten-4">
                                        <v-col class="text-center">품목</v-col>
                                        <v-divider vertical />
                                        <v-col class="text-center">제조원</v-col>
                                        <v-divider vertical />
                                        <v-col class="text-center">품명</v-col>
                                        <v-divider vertical />
                                        <v-col class="text-center">사이즈</v-col>
                                        <v-divider vertical />
                                        <v-col class="text-center">단가</v-col>
                                        <v-divider v-if="estimate.discountType != 'none'" vertical />
                                        <v-col v-if="estimate.discountType != 'none'" class="text-center">할인단가</v-col>
                                        <v-divider vertical />
                                        <v-col class="text-center">수량</v-col>
                                        <v-divider vertical />
                                        <v-col class="text-center">합계</v-col>
                                        <v-divider v-if="estimate.discountType != 'none'" vertical />
                                        <v-col v-if="estimate.discountType != 'none'" class="text-center">할인합계</v-col>
                                        <v-divider vertical />
                                        <v-col class="text-center">비고</v-col>
                                        <v-divider vertical />
                                        <v-col cols="auto" class="text-center">
                                            <v-icon small color="yellow lighten-4">mdi-delete</v-icon>
                                        </v-col>
                                        <v-divider vertical />
                                    </v-row>
                                </v-col>
                            </v-row>
                            <v-row v-for="(space, index) in estimate.data2.material.spaces" :key="index" class="white" align="center">
                                <v-col cols="12" class="pa-0">
                                    <v-divider />
                                </v-col>
                                <v-col cols="2">
                                    <v-row align="center">
                                        <v-col class="pr-2">
                                            <v-text-field v-model="space.name" dense hide-details />
                                        </v-col>
                                        <v-col cols="auto" class="pl-0">
                                            <v-icon small @click="removeSpace(space)">mdi-delete</v-icon>
                                        </v-col>
                                    </v-row>
                                </v-col>
                                <v-divider vertical />
                                <v-col class="py-0">
                                    <v-row v-for="(row, index) in space.rows" :key="index" class="white" align="center">
                                        <v-col>
                                            <v-text-field v-model="row.item" dense hide-details />
                                        </v-col>
                                        <v-divider vertical />
                                        <v-col>
                                            <v-text-field v-model="row.manufacturer" dense hide-details />
                                        </v-col>
                                        <v-divider vertical />
                                        <v-col>
                                            <v-text-field v-model="row.productName" dense hide-details />
                                        </v-col>
                                        <v-divider vertical />
                                        <v-col>
                                            <v-text-field v-model="row.size" dense hide-details />
                                        </v-col>
                                        <v-divider vertical />
                                        <v-col>
                                            <v-text-field v-model="row.unitPrice" dense hide-details @input="calcMaterialSums(row)" />
                                        </v-col>
                                        <v-divider v-if="estimate.discountType != 'none'" vertical />
                                        <v-col v-if="estimate.discountType != 'none'" style="text-align:right;">
                                            <template v-if="estimate.discountType == 'self'">
                                                <v-text-field v-model="row.discountPrice" dense hide-details @input="calcMaterialSums(row)" />
                                            </template>
                                            <template v-else> {{ (+row.discountPrice || 0).format() }}원 </template>
                                        </v-col>
                                        <v-divider vertical />
                                        <v-col>
                                            <v-text-field v-model="row.quantity" dense hide-details @input="calcMaterialSums(row)" />
                                        </v-col>
                                        <v-divider vertical />
                                        <v-col style="text-align:right"> {{ (+row.amount || 0).format() }}원 </v-col>
                                        <v-divider v-if="estimate.discountType != 'none'" vertical />
                                        <v-col v-if="estimate.discountType != 'none'" style="text-align:right"> {{ (+row.discountAmount || 0).format() }}원 </v-col>
                                        <v-divider vertical />
                                        <v-col>
                                            <v-text-field v-model="row.remark" dense hide-details />
                                        </v-col>
                                        <v-divider vertical />
                                        <v-col cols="auto">
                                            <v-icon small @click="removeSpaceRow(space, row)">mdi-delete</v-icon>
                                        </v-col>
                                        <v-divider vertical />
                                        <v-col cols="12" class="pa-0">
                                            <v-divider />
                                        </v-col>
                                    </v-row>
                                    <v-row class="blue-grey lighten-4" justify="center">
                                        <v-col cols="12" class="px-0 py-0">
                                            <v-btn width="100%" text @click="insertSpaceRow(space)"><v-icon small class="mr-2">mdi-plus</v-icon>입력란 추가</v-btn>
                                        </v-col>
                                    </v-row>
                                </v-col>
                            </v-row>
                            <v-row class="blue-grey lighten-4" justify="center">
                                <v-col cols="12" class="pa-0">
                                    <v-divider />
                                </v-col>
                                <v-col cols="12" class="px-0 py-0">
                                    <v-btn width="100%" text @click="insertSpace()"><v-icon small class="mr-2">mdi-plus</v-icon>위치 추가</v-btn>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                    <v-divider class="mx-0" />
                </v-responsive>
                <v-responsive width="100%">
                    <v-divider class="mx-0" />
                    <v-row align="center" class="blue lighten-4 mx-0">
                        <v-col cols="auto" class="py-0 text-center">
                            인건비
                        </v-col>
                        <v-divider vertical />
                        <v-col class="py-0">
                            <v-row class="blue lighten-4" align="center">
                                <v-col cols="2" class="text-center">
                                    기술자
                                </v-col>
                                <v-divider vertical />
                                <v-col class="py-0">
                                    <v-row class="yellow lighten-4">
                                        <v-col class="text-center">등급</v-col>
                                        <v-divider vertical />
                                        <v-col class="text-center">인원</v-col>
                                        <v-divider vertical />
                                        <v-col class="text-center">성명</v-col>
                                        <v-divider vertical />
                                        <v-col class="text-center">단가</v-col>
                                        <v-divider v-if="estimate.discountType != 'none'" vertical />
                                        <v-col v-if="estimate.discountType != 'none'" class="text-center">할인단가</v-col>
                                        <v-divider vertical />
                                        <v-col class="text-center">일수</v-col>
                                        <v-divider vertical />
                                        <v-col class="text-center">합계</v-col>
                                        <v-divider v-if="estimate.discountType != 'none'" vertical />
                                        <v-col v-if="estimate.discountType != 'none'" class="text-center">할인합계</v-col>
                                        <v-divider vertical />
                                        <v-col class="text-center">비고</v-col>
                                        <v-divider vertical />
                                        <v-col cols="auto" class="text-center">
                                            <v-icon small color="yellow lighten-4">mdi-delete</v-icon>
                                        </v-col>
                                        <v-divider vertical />
                                    </v-row>
                                </v-col>
                            </v-row>
                            <v-row v-for="(artificer, index) in estimate.data2.laborCosts.artificers" :key="index" class="white" align="center">
                                <v-col cols="12" class="pa-0">
                                    <v-divider />
                                </v-col>
                                <v-col cols="2">
                                    <v-row align="center">
                                        <v-col class="pr-2">
                                            <v-text-field v-model="artificer.name" dense hide-details />
                                        </v-col>
                                        <v-col cols="auto" class="pl-0">
                                            <v-icon small @click="removeArtificer(artificer)">mdi-delete</v-icon>
                                        </v-col>
                                    </v-row>
                                </v-col>
                                <v-divider vertical />
                                <v-col class="py-0">
                                    <v-row v-for="(row, index) in artificer.rows" :key="index" class="white" align="center">
                                        <v-col>
                                            <v-text-field v-model="row.grade" dense hide-details />
                                        </v-col>
                                        <v-divider vertical />
                                        <v-col>
                                            <v-text-field v-model="row.personnel" dense hide-details @input="calcLaborSums(row)" />
                                        </v-col>
                                        <v-divider vertical />
                                        <v-col>
                                            <v-text-field v-model="row.name" dense hide-details />
                                        </v-col>
                                        <v-divider vertical />
                                        <v-col>
                                            <v-text-field v-model="row.unitPrice" dense hide-details @input="calcLaborSums(row)" />
                                        </v-col>
                                        <v-divider v-if="estimate.discountType != 'none'" vertical />
                                        <v-col v-if="estimate.discountType != 'none'" style="text-align:right;">
                                            <template v-if="estimate.discountType == 'self'">
                                                <v-text-field v-model="row.discountPrice" dense hide-details @input="calcLaborSums(row)" />
                                            </template>
                                            <template v-else>{{ (+row.discountPrice || 0).format() }}원</template>
                                        </v-col>
                                        <v-divider vertical />
                                        <v-col>
                                            <v-text-field v-model="row.days" dense hide-details @input="calcLaborSums(row)" />
                                        </v-col>
                                        <v-divider vertical />
                                        <v-col style="text-align:right;"> {{ (+row.amount || 0).format() }}원 </v-col>
                                        <v-divider v-if="estimate.discountType != 'none'" vertical />
                                        <v-col v-if="estimate.discountType != 'none'" style="text-align:right;"> {{ (+row.discountAmount || 0).format() }}원 </v-col>
                                        <v-divider vertical />
                                        <v-col>
                                            <v-text-field v-model="row.remark" dense hide-details />
                                        </v-col>
                                        <v-divider vertical />
                                        <v-col cols="auto">
                                            <v-icon small @click="removeArtificerRow(artificer, row)">mdi-delete</v-icon>
                                        </v-col>
                                        <v-divider vertical />
                                        <v-col cols="12" class="pa-0">
                                            <v-divider />
                                        </v-col>
                                    </v-row>
                                    <v-row class="blue-grey lighten-4" justify="center">
                                        <v-col cols="12" class="px-0 py-0">
                                            <v-btn width="100%" text @click="insertArtificerRow(artificer)"><v-icon small class="mr-2">mdi-plus</v-icon>입력란 추가</v-btn>
                                        </v-col>
                                    </v-row>
                                </v-col>
                            </v-row>
                            <v-row class="blue-grey lighten-4" justify="center">
                                <v-col cols="12" class="pa-0">
                                    <v-divider />
                                </v-col>
                                <v-col cols="12" class="px-0 py-0">
                                    <v-btn width="100%" text @click="insertArtificer()"><v-icon small class="mr-2">mdi-plus</v-icon>기술자 추가</v-btn>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                    <v-divider class="mx-0" />
                </v-responsive>

                <v-divider />
                <v-row>
                    <v-spacer />
                    <v-col cols="auto">
                        <v-row align="center" class="mr-4">
                            <v-spacer />
                            <v-col cols="auto" class="consultingRate">
                                <v-text-field v-model="estimate.consultingRate" label="컨설팅 마진률(%)" dense hide-details />
                            </v-col>
                        </v-row>
                        <v-row align="center" class="mr-4">
                            <v-col cols="auto" class="py-1 font-weight-bold text-end">공급단가: </v-col>
                            <v-spacer />
                            <v-col cols="auto" class="py-1">{{ supplyAmount.format() }}원</v-col>
                        </v-row>
                        <v-row v-if="estimate.discountType != 'none'" align="center" class="mr-4">
                            <v-col cols="auto" class="py-1 font-weight-bold text-end">할인단가: </v-col>
                            <v-spacer />
                            <v-col cols="auto" class="py-1">{{ discountAmount.format() }}원</v-col>
                        </v-row>
                        <v-row align="center" class="mr-4">
                            <v-col cols="auto" class="py-1 font-weight-bold text-end">컨설팅: </v-col>
                            <v-spacer />
                            <v-col cols="auto" class="py-1">{{ consulting.format() }}원</v-col>
                        </v-row>
                        <v-row v-if="estimate.vatEnable" align="center" class="mr-4">
                            <v-col cols="auto" class="py-1 font-weight-bold text-end">부가세: </v-col>
                            <v-spacer />
                            <v-col cols="auto" class="py-1">{{ vat.format() }}원</v-col>
                        </v-row>
                        <v-row align="center" class="mr-4">
                            <v-col cols="auto" class="py-1 font-weight-bold text-end">총금액: </v-col>
                            <v-spacer />
                            <v-col cols="auto" class="py-1">{{ totalAmount.format() }}원</v-col>
                        </v-row>
                    </v-col>
                </v-row>
            </v-card-text>
            <v-divider />
            <v-card-actions>
                <v-radio-group v-model="estimate.vatEnable" row dense hide-details label="부가세 항목" class="mt-0 ml-2">
                    <v-radio label="사용안함" :value="false"></v-radio>
                    <v-radio label="추가" :value="true"></v-radio>
                </v-radio-group>
                <v-divider vertical />
                <v-radio-group v-model="estimate.discountType" row dense hide-details label="할인단가적용" class="mt-0 ml-4">
                    <v-radio label="사용안함" value="none"></v-radio>
                    <v-radio label="개별할인" value="self"></v-radio>
                    <v-radio label="일괄할인" value="rate"></v-radio>
                    <v-responsive width="50">
                        <v-text-field v-model="estimate.discountRate" dense hide-details class="consultingRate mb-1">
                            <v-icon slot="append" x-small class="mt-2">mdi-percent</v-icon>
                        </v-text-field>
                    </v-responsive>
                </v-radio-group>
                <v-spacer></v-spacer>
                <v-btn color="grey" text @click="close()">{{ editable ? "취소" : "닫기" }}</v-btn>
                <v-btn v-if="editable" color="primary" text @click="save()">저장</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import api from "@/api";
export default {
    props: {
        value: { type: Object, default: null },
        editable: { type: Boolean, default: true },
    },
    data() {
        return {
            show: false,

            estimate: null,
        };
    },
    methods: {
        open() {
            this.show = true;
            this.$set(this.$data, "estimate", JSON.parse(JSON.stringify(this.value)));
            this.estimate = {
                discountType: "none",
                discountRate: 0,
                ...this.estimate,
                file: this.value.file,
            };

            if (!this.estimate.data2.material.spaces.length) this.insertSpace();
            if (!this.estimate.data2.laborCosts.artificers.length) this.insertArtificer();
        },
        close() {
            this.show = false;
            if (!this.editable) this.$emit("resetEstimate");
        },
        save() {
            this.$emit("input", { ...this.value, ...this.estimate });
            this.show = false;
        },
        insertSpace() {
            this.$set(this.estimate.data2.material.spaces, this.estimate.data2.material.spaces.length, {
                name: null,
                rows: [
                    {
                        item: null,
                        manufacturer: null,
                        productName: null,
                        size: null,
                        unitPrice: null,
                        discountRate: null,
                        salePrice: null,
                        quantity: null,
                        amount: null,
                        remark: null,
                    },
                ],
            });
        },
        insertSpaceRow(space) {
            this.$set(space.rows, space.rows.length, {
                item: null,
                manufacturer: null,
                productName: null,
                size: null,
                unitPrice: null,
                discountRate: null,
                salePrice: null,
                quantity: null,
                amount: null,
                remark: null,
            });
        },
        removeSpace(space) {
            this.estimate.data2.material.spaces.splice(
                this.estimate.data2.material.spaces.findIndex((data) => data == space),
                1
            );
        },
        removeSpaceRow(space, row) {
            space.rows.splice(
                space.rows.findIndex((data) => data == row),
                1
            );
        },
        insertArtificer() {
            this.$set(this.estimate.data2.laborCosts.artificers, this.estimate.data2.laborCosts.artificers.length, {
                name: null,
                rows: [
                    {
                        grade: null,
                        personnel: null,
                        name: null,
                        unitPrice: null,
                        discountRate: null,
                        salePrice: null,
                        days: null,
                        amount: null,
                        remark: null,
                    },
                ],
            });
        },
        insertArtificerRow(artificer) {
            this.$set(artificer.rows, artificer.rows.length, {
                grade: null,
                personnel: null,
                name: null,
                unitPrice: null,
                discountRate: null,
                salePrice: null,
                days: null,
                amount: null,
                remark: null,
            });
        },
        removeArtificer(artificer) {
            this.estimate.data2.laborCosts.artificers.splice(
                this.estimate.data2.laborCosts.artificers.findIndex((data) => data == artificer),
                1
            );
        },
        removeArtificerRow(artificer, row) {
            artificer.rows.splice(
                artificer.rows.findIndex((data) => data == row),
                1
            );
        },
        remove(item) {
            this.estimate.data1.splice(
                this.estimate.data1.findIndex((data) => data == item),
                1
            );
        },
        calcMaterialSums(row) {
            const { discountRate, discountType } = this.estimate;
            const { unitPrice = 0, discountPrice = 0, quantity = 0 } = row;

            row.amount = +unitPrice * +quantity;
            if (discountType == "rate") {
                row.discountPrice = Math.floor((+unitPrice * (100 - +discountRate)) / 100);
                row.discountAmount = +row.discountPrice * +quantity;
            }
            if (discountType == "self") {
                row.discountAmount = +discountPrice * +quantity;
            }
            if (discountType == "none") {
                row.discountPrice = null;
                row.discountAmount = null;
            }
        },
        calcLaborSums(row) {
            const { discountRate, discountType } = this.estimate;
            const { unitPrice = 0, discountPrice = 0, personnel = 0, days = 0 } = row;

            row.amount = +unitPrice * +days * +personnel;
            if (discountType == "rate") {
                row.discountPrice = Math.floor((+unitPrice * (100 - +discountRate)) / 100);
                row.discountAmount = +row.discountPrice * +days * +personnel;
            }
            if (discountType == "self") {
                row.discountAmount = +discountPrice * +days * +personnel;
            }
            if (discountType == "none") {
                row.discountPrice = null;
                row.discountAmount = null;
            }
        },
        setDiscountPrice() {
            for (var space of this.estimate.data2.material.spaces) {
                for (var row of space.rows) {
                    this.calcMaterialSums(row);
                }
            }
            for (var artificer of this.estimate.data2.laborCosts.artificers) {
                for (var row of artificer.rows) {
                    this.calcLaborSums(row);
                }
            }
        },
        async tempSave() {
            try {
                const { estimate } = await api.console.estimate.postEstimate({ type: "data2", isTemp: true, ...this.estimate });
                alert("저장되었습니다.");
            } catch (error) {
                this.$handleError(error);
            }
        },
        async tempLoad() {
            try {
                const {
                    estimate: { _id, ...temp },
                } = await api.console.estimate.getEstimate({ params: { type: "data2", isTemp: true } });
                this.estimate = { ...temp };
            } catch (error) {
                this.$handleError(error);
            }
        },
    },
    computed: {
        discountEnabled() {
            return this.estimate.discountType == "none" ? false : true;
        },
        supplyAmount() {
            var materialPrice = this.estimate.data2.material.spaces.reduce((amount, space) => {
                return (
                    +space.rows.reduce((amount, row) => {
                        return (+row.amount || 0) + amount;
                    }, 0) + amount
                );
            }, 0);
            var laborCostsPrice = this.estimate.data2.laborCosts.artificers.reduce((amount, artificer) => {
                return (
                    +artificer.rows.reduce((amount, row) => {
                        return (+row.amount || 0) + amount;
                    }, 0) + amount
                );
            }, 0);
            return materialPrice + laborCostsPrice;
        },
        discountAmount() {
            var materialPrice = this.estimate.data2.material.spaces.reduce((amount, space) => {
                return (
                    +space.rows.reduce((amount, row) => {
                        return (+row.discountAmount || 0) + amount;
                    }, 0) + amount
                );
            }, 0);
            var laborCostsPrice = this.estimate.data2.laborCosts.artificers.reduce((amount, artificer) => {
                return (
                    +artificer.rows.reduce((amount, row) => {
                        return (+row.discountAmount || 0) + amount;
                    }, 0) + amount
                );
            }, 0);
            return materialPrice + laborCostsPrice;
        },
        amount() {
            return !this.discountEnabled ? this.supplyAmount : this.discountAmount;
        },
        consulting() {
            return (this.amount * (this.estimate.consultingRate || 0)) / 100;
        },
        vat() {
            return (+this.amount + this.consulting) * 0.1;
        },
        totalAmount() {
            return this.estimate.vatEnable ? +this.amount + this.consulting + this.vat : +this.amount + this.consulting;
        },
    },
    watch: {
        "estimate.discountType"() {
            switch (this.estimate.discountType) {
                case "rate": {
                    this.setDiscountPrice();
                    break;
                }
            }
        },
        "estimate.discountRate"() {
            switch (this.estimate.discountType) {
                case "rate": {
                    this.setDiscountPrice();
                    break;
                }
            }
        },
    },
};
</script>

<style>
.estimate-2 .v-input input {
    text-align: center;
}
.estimate-2 .consultingRate input {
    text-align: right;
}
</style>
